<!--  -->
<template>
  <div class="web-view">
    <iframe
      :src="courseTabDetails.redirectUrl"
    ></iframe>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {};
  },
  props: {
    courseTabDetails: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.web-view {
  position: absolute;
  top: 80px;
  width: 100%;
  iframe {
    width: 100%;
    min-height: calc(100vh - 100px);
  }
}
</style>
